import React from 'react'
import _ from 'lodash'
import m from 'moment'
import { compose, withHandlers } from 'recompose'
import numeral from 'numeral'
import { toOptions, renderOptions } from '../../../modules/options'

const hours = _.range(0, 24, 1)
const minutes = _.range(0, 61, 1)

const dateOptions = {
  hours: toOptions(hours),
  minutes: toOptions(minutes, {
    getTitle: minute => numeral(minute).format('00'),
  }),
}

const DatePicker = ({ value, handleChange }) => {
  const dateValue = m(value)
  return (
    <div className="field is-grouped">
      <div className="control">
        <div className="select is-primary is-small">
          <select
            value={dateValue.get('hour')}
            onChange={handleChange}
            name="hour"
          >
            {renderOptions(dateOptions.hours)}
          </select>
        </div>
      </div>
      <div className="control">
        <div className="select is-primary is-small">
          <select
            value={dateValue.get('minute')}
            onChange={handleChange}
            name="minute"
          >
            {renderOptions(dateOptions.minutes)}
          </select>
        </div>
      </div>
    </div>
  )
}

function updatedDate(currentDate, updatePath, value) {
  const newDate = currentDate.clone()
  switch (updatePath) {
    case 'hour':
      return newDate.hour(value)
    case 'minute':
      return newDate.minute(value)
    default:
      return undefined
  }
}

export default compose(
  withHandlers({
    handleChange: ({ value, onChange }) => e => {
      onChange(updatedDate(value, e.target.name, e.target.value))
    },
  }),
)(DatePicker)



// WEBPACK FOOTER //
// ./src/components/templates/dateTimePicker/TimePicker.js